<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>View Follow-Up Details</h2>
  </div>

  <!-- Section to display quote ID and client name -->
  <div class="row mb-3 border p-4 rounded">
    <div class="col-md-4">
      <div class="d-flex align-items-center">
        <strong class="me-2">Quote ID:</strong>
        <span>{{ quotationData?.quotationFields?.id }}</span>
      </div>
    </div>
    <div class="col-md-4">
      <div class="d-flex align-items-center">
        <strong class="me-2">Company Name:</strong>
        <span>{{ masterCommonServices?.getClientName(quotationData?.quotationFields?.quotationCompanyId ||
          -1)?.companyName || '-' }}</span>
      </div>
    </div>
    <div class="col-md-4">
      <div class="d-flex align-items-center"></div>
      <button class="btn btn-primary" (click)="redirectToQuotationDetails()">
        View Quotation Details
      </button>
    </div>
  </div>
</div>
<app-followup [quotationId]="quotationData?.quotationFields?.id"></app-followup>
